import { render, staticRenderFns } from "./PaginatorSkeleton.vue?vue&type=template&id=7c318767&scoped=true&"
import script from "./PaginatorSkeleton.vue?vue&type=script&lang=js&"
export * from "./PaginatorSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c318767",
  null
  
)

export default component.exports